import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=32fea592"
import script from "./EditDocument.vue?vue&type=script&lang=ts"
export * from "./EditDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports